import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const AboutHeader = () => {
  const location = useLocation();

  // Upgraded mapping to include actual paths for working breadcrumb links
  const pageDetails = {
    '/': { title: 'Home', breadcrumb: [{ name: 'Home', path: '/' }] },
    '/about': { title: 'About Us', breadcrumb: [{ name: 'Home', path: '/' }, { name: 'About Us', path: '/about' }] },
    '/user-consent': { title: 'User Consent', breadcrumb: [{ name: 'Home', path: '/' }, { name: 'User Consent', path: '/user-consent' }] },
    '/packages': { title: 'Packages', breadcrumb: [{ name: 'Home', path: '/' }, { name: 'Packages', path: '/packages' }] },
    '/contact': { title: 'Contact Us', breadcrumb: [{ name: 'Home', path: '/' }, { name: 'Contact Us', path: '/contact' }] },
  };

  // Get current page or default 404
  const currentPage = pageDetails[location.pathname] || {
    title: 'Page Not Found',
    breadcrumb: [{ name: 'Home', path: '/' }, { name: '404', path: '#' }],
  };

  return (
    <div className="relative w-full py-14 md:py-16 lg:py-20 flex items-center justify-center overflow-hidden font-sans selection:bg-white selection:text-black mt-[40px]">

      {/* --- BACKGROUND (professional deep-navy brand gradient) --- */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            'linear-gradient(120deg, #0f2942 0%, #1e6091 55%, #143b5c 100%)',
        }}
      ></div>

      {/* Soft radial highlight for depth */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_80%_at_50%_0%,rgba(255,255,255,0.10),transparent_70%)]"></div>

      {/* Subtle diagonal sheen */}
      <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/[0.04] to-transparent"></div>

      {/* Bottom fade for clean separation */}
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/20 to-transparent"></div>

      {/* --- CONTENT --- */}
      <div className="relative z-10 container mx-auto px-6 pt-10 text-center flex flex-col items-center animate-fade-in-up">
        
        {/* Page Title */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-white tracking-tight mb-8 drop-shadow-2xl">
          {currentPage.title}
        </h1>

        {/* Premium Glassmorphic Breadcrumb */}
        <nav className="inline-flex items-center space-x-2 md:space-x-3 text-sm md:text-base font-bold bg-white/10 backdrop-blur-md px-8 py-3.5 rounded-full border border-white/20 shadow-xl">
          {currentPage.breadcrumb.map((crumb, index) => {
            const isLast = index === currentPage.breadcrumb.length - 1;
            
            return (
              <div key={index} className="flex items-center space-x-2 md:space-x-3">
                {isLast ? (
                  // Active/Current Page (Solid White)
                  <span className="text-white drop-shadow-md tracking-wide">
                    {crumb.name}
                  </span>
                ) : (
                  <>
                  
                    <Link 
                      to={crumb.path} 
                      className="text-zinc-400 hover:text-white transition-colors duration-300 tracking-wide"
                    >
                      {crumb.name}
                    </Link>
                    
                    {/* Custom Chevron Separator */}
                    <svg 
                      className="w-3.5 h-3.5 text-zinc-500" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor" 
                      strokeWidth={3}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                  </>
                )}
              </div>
            );
          })}
        </nav>
        
      </div>

      <style jsx>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
      `}</style>
    </div>
  );
};

export default AboutHeader;